var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"vue-view-toggle"},_vm._l((_vm.viewModes),function(view){return _c('div',{staticClass:"view-toggle-item",class:{'active': _vm.viewMode === view.slug}},[_c('button',{class:{'grid-view': view.slug === 'grid'},on:{"click":function($event){return _vm.handleClick(view.slug)}}},[_vm._v(_vm._s(view.title))])])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }